<template>
  <div class="header-menu-wrap">
    <template v-for="item in menuList">
      <div
        :key="item.title"
        v-if="item.status === '0' && item.isShow"
        class="operation-icon"
        :class="{ activeItem: item.title === selectItem }"
        @click="handleSubMenClick(item)"
      >
        <IconWrap :width="26" :height="27" :url="item.picPath"></IconWrap>
        <div class="text">
          <span>{{ item.title }}</span>
          <span>{{ item.tips }}</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { ROUTER_MAP } from '../../configs/menuRouter'
import { menuList } from './configs/config'
import {is_cloneDeep} from '@/utils/cloneDeep.js'

export default {
  data () {
    return {
      menuList: is_cloneDeep(menuList),
      selectItem: ''
    }
  },
  watch: {
    // 侦听器导航菜单已选项的变化
    stateSelectedKeys: {
      handler: function (newVal) {
        this.selectItem = newVal[0]
        // 
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters('headerMenu', [
      'stateMenuList',
      'stateSelectedKeys',
      'stateRouterPath'
    ])
  },
  mounted() {
    this.getMenu()
    this.$bus.$on('editMenu',()=>{
      this.getMenu()
    })
  },
  //mounted () {},
  methods: {
    ...mapMutations('headerMenu', ['updateMenuItemStatus']),
    handleSubMenClick (item) {
      const key = item.title
      this.selectItem = key
      const routerPath = ROUTER_MAP[key]
      // this.$store.commit('headerMenu/updateMenuList',{list: item.children})
        this.$router.push({ path: `/${routerPath}`, query: {code:item.code}})
      
    },
    // 获取菜单并根据菜单去修改
    async getMenu () {
      this.$store.dispatch('headerMenu/setMenu',this.menuList)
    }
  },
  destroyed(){
    this.$bus.$off('editMenu')
  }
}
</script>
